import * as React from "react";
import { useAppointmentContext } from "../../../../../context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import useVirtualAppointment from "./use-virtual-appointment.js";
import { fromArrayToString } from "../../../../../../../utils/v3/utils/from-array-to-string.js";
import useBookAppointmentStoreById from "../../../../api/v3/pages/BookAppointment/hooks/api/use-book-appointment-store-by-id.js";
const useBookAppointmentStoreWithUrlParam = () => {
  const [, { queryParams }] = useRoutingContext();
  const filterWithGroupId = fromArrayToString(queryParams.groupId);
  const [getBookAppointmentStore, { called, data, loading, error }] = useBookAppointmentStoreById({
    isGroupIdEnabled: fromArrayToString(queryParams.groupId) === filterWithGroupId ? filterWithGroupId : null
  });
  const [{ setStore }, { store }] = useAppointmentContext();
  const [{ getAppointmentTypeData, getStoreByIdData }, { globalStoreId: virtualStoreId }] = useVirtualAppointment();
  React.useEffect(() => {
    if (error) {
      console.error(error);
      return;
    }
    const { storeId: storeIdFromUrl } = queryParams;
    const storeId = fromArrayToString(storeIdFromUrl);
    if (loading || !storeId || storeId === store?.globalStoreId) {
      return;
    }
    const isVirtualAppointmentStoreId = storeId === virtualStoreId;
    if (isVirtualAppointmentStoreId) {
      setStore(getStoreByIdData(void 0, getAppointmentTypeData()));
      return;
    }
    getBookAppointmentStore(storeId);
  }, [
    queryParams,
    store,
    loading,
    error,
    virtualStoreId,
    setStore,
    getStoreByIdData,
    getAppointmentTypeData,
    getBookAppointmentStore
  ]);
  React.useEffect(() => {
    if (!called || !data || loading) {
      return;
    }
    setStore(data);
  }, [called, data, loading, setStore]);
};
export {
  useBookAppointmentStoreWithUrlParam as default
};
//# sourceMappingURL=use-book-appointment-store-with-url-param.js.map
